<template>
  <div>
    <modal-cadu close :width="1131.52" v-model="valueData">
      <div slot="all" class="py-10 px-10">
        <div slot="header" class="primary1--text headline font-weight-bold">
          {{ mode === 'view' ? 'VISUALIZAR' : 'EDITAR' }} QUANTIDADE DE COLABORADORES
        </div>
        <div slot="body">
          <v-row>
            <v-col cols="3">
              <validation-provider name="competencia" mode="eager" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Competência"
                  v-model="competencia"
                  icon="calendar"
                  v-mask="'##/####'"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  disabled
                />
              </validation-provider>
            </v-col>
            <v-col cols="3">
              <validation-provider name="ultimaAtualizacao" mode="eager" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Última Atualização"
                  v-model="ultimaAtualizacao"
                  icon="calendar"
                  v-mask="'##/##/####'"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  disabled
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <GridColaborador
                @totalCola="(value) => (totalColaboradorA = value)"
                @totalPcd="(value) => (totalPcdA = value)"
                @totalGeral="(value) => (totalGeralA = value)"
                :disabled="mode === 'view'"
                ref="grid"
                texto="COLABORADORES DA UNIMED"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <GridColaborador
                @totalCola="(value) => (totalColaboradorB = value)"
                @totalPcd="(value) => (totalPcdB = value)"
                @totalGeral="(value) => (totalGeralB = value)"
                :disabled="mode === 'view'"
                ref="gridProprio"
                texto="COLABORADORES DOS SERVIÇOS PRÓPRIOS"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <div>
                <v-row align="center">
                  <v-col class="pa-2" cols="12" sm="3" md="3" lg="3">
                    <div class="primary1--text title">TOTAL UNIMED</div>
                  </v-col>
                  <v-col class="pa-2" cols="12" sm="3" md="3" lg="3">
                    <input-cadu
                      textAlign="end"
                      colorBgField="#333"
                      colorInput="white"
                      :mask="[
                        '####',
                        '#.###',
                        '##.###',
                        '###.###',
                        '####.###',
                        '#.###.###',
                        '##.###.###',
                        '###.###.###',
                        '#.###.###.##'
                      ]"
                      disabled
                      :value="totalColaborador"
                    />
                  </v-col>
                  <v-col class="pa-2 ml-0" cols="12" sm="3" md="3" lg="3">
                    <input-cadu
                      textAlign="end"
                      colorBgField="#333"
                      colorInput="white"
                      :mask="[
                        '####',
                        '#.###',
                        '##.###',
                        '###.###',
                        '####.###',
                        '#.###.###',
                        '##.###.###',
                        '###.###.###',
                        '#.###.###.##'
                      ]"
                      disabled
                      :value="totalPcd"
                    />
                  </v-col>
                  <v-col class="pa-2 ml-0" cols="12" sm="3" md="3" lg="3">
                    <input-cadu
                      textAlign="end"
                      colorBgField="#333"
                      colorInput="white"
                      :mask="[
                        '####',
                        '#.###',
                        '##.###',
                        '###.###',
                        '####.###',
                        '#.###.###',
                        '##.###.###',
                        '###.###.###',
                        '#.###.###.##'
                      ]"
                      disabled
                      :value="totalGeral"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
        <div slot="footer">
          <div v-if="mode === 'view'">
            <v-row align="end" justify="end">
              <v-col cols="auto">
                <button-cadu
                  @click="$emit('input', false)"
                  :backColor="$vuetify.theme.themes.light.primary2"
                  text="VOLTAR"
                />
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-row align="start" justify="start">
              <v-col cols="auto">
                <button-cadu outline @click="verificarMudanca"> CANCELAR </button-cadu>
              </v-col>
              <v-row align="end" justify="end" class="mr-2">
                <v-col cols="auto">
                  <button-cadu :backColor="$vuetify.theme.themes.light.primary2" class="px-4" @click="clean">
                    LIMPAR
                  </button-cadu>
                </v-col>
                <v-col cols="auto">
                  <button-cadu @click="putColaborador"> SALVAR </button-cadu>
                </v-col>
              </v-row>
            </v-row>
          </div>
        </div>
      </div>
    </modal-cadu>
    <modal-cancelar :value="showModalCancelar" @input="fecharModalCancelar" @cancelar-edicao="cancelarEdicao()" />
    <overlay-loading :value="loadingOverlay" />
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { mask } from 'vue-the-mask'
import Colaborador from '@/services/Perfil/Colaborador'
import GridColaborador from '../../GridColaborador'
import { isEqual } from 'lodash'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  directives: {
    mask
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  components: {
    ValidationProvider,
    GridColaborador
  },
  data() {
    return {
      valueData: this.value,
      competencia: '08/2018',
      ultimaAtualizacao: '01/07/2018',
      totalColaboradorA: 0,
      totalPcdA: 0,
      totalGeralA: 0,
      totalColaboradorB: 0,
      totalPcdB: 0,
      totalGeralB: 0,
      colaboradores: {},
      colaboradoresProprios: {},
      loadingOverlay: false,
      id: -1,
      tokenBearer: localStorage.getItem('tokenBearer'),
      cloneColaborador: {},
      showModalCancelar: false,
      cloneCloneColaborador: {}
    }
  },
  methods: {
    async fecharModalCancelar() {
      this.showModalCancelar = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    verificarMudanca() {
      let newObj = {
        id: this.id,
        competencia: this.competencia,
        dataAtualizacao: this.ultimaAtualizacao,
        justificativa: null,
        usuarioAtualizacao: {
          id: 5506,
          nome: 'Usuário Teste',
          unimed: {
            id: 2,
            codigo: 999,
            nomeFantasia: 'UNIMED BRASIL 2',
            textoExibicao: null
          }
        },
        editavel: this.editavel,
        itens: [this.$refs.grid.returnValues(), this.$refs.gridProprio.returnValues()]
      }

      newObj.usuarioAtualizacao = this.cloneColaborador.usuarioAtualizacao

      if (!isEqual(this.cloneColaborador, newObj)) {
        this.showModalCancelar = true
      } else {
        this.showModalCancelar = false
        this.$emit('input', false)
      }
    },
    cancelarEdicao() {
      this.start(this.cloneCloneColaborador)
      this.showModalCancelar = false
      this.$emit('input', false)
    },
    async start(row) {
      this.id = row.id
      let itens = row.itens
      await this.$nextTick()

      if (this.$refs.grid) this.$refs.grid.modelValues(itens.filter((el) => !el.servicoProprio))

      if (this.$refs.gridProprio) this.$refs.gridProprio.modelValues(itens.filter((el) => el.servicoProprio))

      this.competencia = row.competencia
      this.ultimaAtualizacao = row.dataAtualizacao
      this.editavel = row.editavel
      this.cloneColaborador = row
      this.cloneCloneColaborador = { ...row }

      if (!!this.$refs.grid && !!this.$refs.gridProprio)
        this.cloneColaborador.itens = [this.$refs.grid.returnValues(), this.$refs.gridProprio.returnValues()]
    },
    clean() {
      this.$refs.grid.clean()
      this.$refs.gridProprio.clean()
    },
    async putColaborador(justificativa) {
      if (
        (await this.$refs.grid.$refs.observer.validate()) &&
        (await this.$refs.gridProprio.$refs.observer.validate())
      ) {
        this.loadingOverlay = true
        let colaborador = new Colaborador(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        this.colaboradores = this.$refs.grid.returnValues()
        this.colaboradoresProprios = this.$refs.gridProprio.returnValues()

        let data = {
          competencia: this.competencia,
          id: this.id,
          itens: this.itens,
          justificativa
        }

        try {
          let response = await colaborador.putColaborador(data)
          let mensagem = response.data.mensagem
          let gerouPendencia = response.data.gerouPendencia
          if (gerouPendencia) {
            EventBus.$emit('pendenteModal', { mensagem, gerouPendencia })
          } else {
            this.id = response.data.idCompetencia
            this.$emit('success')
          }
          EventBus.$emit('resolverAlertaNotificaoPendente', { tipoNotificacao: 'NUMERO_COLABORADORES' })
        } catch (err) {
          this.$emit('error', err.response)
        }
        this.loadingOverlay = false
      }
    }
  },
  computed: {
    isMonthEmpty() {
      return this.allowedMonths.length === 0
    },
    totalColaborador() {
      let a = this.totalColaboradorA * 1 || 0
      let b = this.totalColaboradorB * 1 || 0
      let total = (a + b) * 1 || 0
      return total
    },
    totalPcd() {
      let a = this.totalPcdA * 1 || 0
      let b = this.totalPcdB * 1 || 0
      let total = (a + b) * 1 || 0
      return total
    },
    totalGeral() {
      let a = this.totalGeralA * 1 || 0
      let b = this.totalGeralB * 1 || 0
      let total = (a + b) * 1 || 0
      return total
    },
    itens() {
      return [
        {
          pcd: false,
          quantidadeItens: this.colaboradores.diretor,
          servicoProprio: false,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.gestor,
          servicoProprio: false,
          tipoItem: 'GESTOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.colaborador,
          servicoProprio: false,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.estagiario,
          servicoProprio: false,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.aprendiz,
          servicoProprio: false,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradores.temporario,
          servicoProprio: false,
          tipoItem: 'TEMPORARIO'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.diretor,
          servicoProprio: true,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.gestor,
          servicoProprio: true,
          tipoItem: 'GESTOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.colaborador,
          servicoProprio: true,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.estagiario,
          servicoProprio: true,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.aprendiz,
          servicoProprio: true,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: false,
          quantidadeItens: this.colaboradoresProprios.temporario,
          servicoProprio: true,
          tipoItem: 'TEMPORARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdDiretor,
          servicoProprio: false,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdGestor,
          servicoProprio: false,
          tipoItem: 'GESTOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdColaborador,
          servicoProprio: false,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdEstagiario,
          servicoProprio: false,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdAprendiz,
          servicoProprio: false,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradores.pcdTemporario,
          servicoProprio: false,
          tipoItem: 'TEMPORARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdDiretor,
          servicoProprio: true,
          tipoItem: 'DIRETOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdGestor,
          servicoProprio: true,
          tipoItem: 'GESTOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdColaborador,
          servicoProprio: true,
          tipoItem: 'COLABORADOR'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdEstagiario,
          servicoProprio: true,
          tipoItem: 'ESTAGIARIO'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdAprendiz,
          servicoProprio: true,
          tipoItem: 'JOVEM_APRENDIZ'
        },
        {
          pcd: true,
          quantidadeItens: this.colaboradoresProprios.pcdTemporario,
          servicoProprio: true,
          tipoItem: 'TEMPORARIO'
        }
      ]
    }
  },
  watch: {
    value() {
      this.valueData = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}
</script>
